import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { StatisticsExternalFiltro } from 'src/app/core/entities/statisticsexternalfiltro.model';
import { StatisticsExternal } from 'src/app/core/entities/statisticsexternal.model';
import { DatePipe } from '@angular/common';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { StatisticsExternalService } from 'src/app/core/repositories/statisticsexternal.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-statistisexteranl',
  templateUrl: './statistisexteranl.component.html',
  styleUrls: ['./statistisexteranl.component.scss']
})
export class StatistisexteranlComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;

  loading: boolean = true;
  tabla: boolean = true;
  mensajeError: boolean = false;

  valores: StatisticsExternalFiltro = new StatisticsExternalFiltro();

  allstatistics: StatisticsExternal[] = new Array<StatisticsExternal>();
  allstatisticsFiltro: StatisticsExternal[] = new Array<StatisticsExternal>();
  statistics: StatisticsExternal[] = new Array<StatisticsExternal>();

  constructor(private statisticsService: StatisticsExternalService,
    private datePipe: DatePipe) {
      super(); 
    }

    ngOnInit(){
    }
  
    /**
    * @description
    * Nos traemos todos los registors dependiendo del filtro
    */
    createCa(){
      this.statisticsService.postStatisticsExternalFiltro(this.valores).subscribe((res: any) => {
        console.log(res);
        this.loading = false;
        this.tabla = false;
  
        this.allstatistics = _.cloneDeep(res);
        this.allstatistics = _.orderBy(this.allstatistics, 'dates').reverse();
        for(let i = 0; i < this.allstatistics.length; i++){
          let datepipe = this.datePipe.transform(this.allstatistics[i].createdAt, 'dd/MM/yyyy HH:mm')
          if(datepipe){
            this.allstatistics[i].dateString = datepipe;
          }
        }
  
        console.log(this.allstatistics);
  
        this.allstatisticsFiltro = _.cloneDeep(this.allstatistics);
        this.statistics = _.cloneDeep(this.allstatistics);
  
      },(error: any) => {
        console.log("Error: " + error);
        this.loading = false;
        this.mensajeError = true;
      });
    }
  
    /**
    * @description
    * Filtro para todos las columnas de la tabla
    */
    public filterGlobalStatistics(text: string, num: number){
      text != null && text != undefined ? text.trim() : "";
      let items = [];
      let originalStatistics = new Array<StatisticsExternal>();
      originalStatistics  = _.cloneDeep(this.allstatisticsFiltro);
  
      let registro : string = "";
  
      if (text != "") {
        for (let i = 0; i < originalStatistics.length; i++) {
          let match = false;
          let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());
  
          switch(num){
            case 1:{
              registro = _.deburr(_.trim(originalStatistics[i].rol).toLocaleLowerCase());
              break;
            }
            case 2:{
              registro = _.deburr(_.trim(originalStatistics[i].nifinteressat).toLocaleLowerCase());
              break;
            }
            case 3: {
              registro = _.deburr(_.trim(originalStatistics[i].nifrepresentant).toLocaleLowerCase());
              break;
            }
            case 4: {
              registro = _.deburr(_.trim(originalStatistics[i].dateString).toLocaleLowerCase());
              break;
            }
            case 5: {
              registro = _.deburr(_.trim(originalStatistics[i].ip).toLocaleLowerCase());
              break;
            }
          }
  
          if (filterTxt != "" && _.includes(registro, filterTxt)) {
            match = true;
          } else {
            continue;
          }
  
          if (match) {
            items.push(_.cloneDeep(originalStatistics[i]));
          }
        }
        this.allstatistics = items;
      } else {
        this.allstatistics = originalStatistics;
      }
  
    }
  
    /**
    * @description
    * Desabilitamos boton descarga SGV si no hay datos
    */
    deshabilitar(){
      if(this.allstatistics.length < 1){
        return true;
      }else{
        return false;
      }
      
    }
  
    /**
    * @description
    * Descarga de ldocumento SGV
    */
    download(){
      const json = JSON.stringify(this.allstatistics);
      this.downloadFile(json, 'auditoria_externa');
    }
  
    /**
    * @description
    * Ganeración de ldcumento GSV con los datos de las tablas
    */
    downloadFile(data: any, filename='data') {
      let csvData = this.ConvertToCSV(data, ['id','rol', 'nifinteressat', 'nifrepresentant', 'dateString', 'ip']);
      let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
      let dwldLink = document.createElement("a");
      let url = URL.createObjectURL(blob);
      let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
      if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_blank");
      }
      dwldLink.setAttribute("href", url);
      dwldLink.setAttribute("download", filename + ".csv");
      dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
    }
  
    /**
    * @description
    * Conversion de los datos de las tablas para pasarlos al documento CSV, añadimos titulos en cabezera.
    */
    ConvertToCSV(objArray: any, headerList: any) {
      let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      let str = '';
      let row = 'registro;';
  
      for (let index in headerList) {
          row += headerList[index] + ';';
      }
      row = row.slice(0, -1);
      str += row + '\r\n';
      for (let i = 0; i < array.length; i++) {
          let line = (i+1)+'';
          for (let index in headerList) {
             let head = headerList[index];
  
              line += ';' + array[i][head];
          }
          str += line + '\r\n';
      }
      return str;
    }

}
